import { render, staticRenderFns } from "./UploadsDiversos.vue?vue&type=template&id=569b2f36"
import script from "./UploadsDiversos.vue?vue&type=script&lang=js"
export * from "./UploadsDiversos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports